import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { Task } from "../../../../task/task";
import { useAdminUserOptions } from "../../../adminUser/useAdminUserOptions";

import { CloseCaseNoteModel, CloseTaskNoteForm } from "./CloseTaskNoteForm";

interface Props {
    task: TaskModel;
    customerId: string;
    onCancelTask: (taskId: string, closingNote: string) => void;
}

export const CloseCaseModalItem: React.FunctionComponent<Props> = (props: Props) => {

    const adminUserOptions = useAdminUserOptions();

    const onCancelTask = async (model: CloseCaseNoteModel) => {
        if (props.task.cancelled === false) {
            props.onCancelTask(props.task.id, model.closingNote);
        }
    };

    const actions = props.task.cancelled === false && (<CloseTaskNoteForm taskId={props.task.id} save={onCancelTask} />);

    return (
        <Task task={props.task} customerId={props.customerId} actions={actions} adminUserOptions={adminUserOptions} />
    );
};
